import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User } from '@/types'

interface UserState {
  currentUser: User | null
}

const initialState: UserState = {
  currentUser: null
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload // Correctly set the user
    },
    clearUser: (state) => {
      state.currentUser = null // Correctly clear the user
    },
  }
})

export const { setCurrentUser, clearUser } = userSlice.actions
export default userSlice.reducer
